export default __webpack_public_path__ + "static/media/Alibaba - Logo2.4132cb5e.png";